import { Declaration } from 'store/declarations/declaration';

// The BE lists the H1 and the sibling B1s for a B1, but a B1 only links to its H1 - each B1 has one.
// An H1 links to all of its B1s, so its list is shown as it is.
export const getLinkedMirroredDeclarations = (
    declaration: Declaration | undefined,
    listedDeclarations: Declaration[]
): Declaration[] => {
    if (!declaration) return [];

    const isMirroredB1 = Boolean(declaration.mirrored);
    if (!isMirroredB1) return listedDeclarations;

    return listedDeclarations.filter((listed) => listed.id === declaration.mirrorDeclarationIdLink);
};
